<template>
    <div data-v-6ebeef4c>
        <usertop></usertop>
        <div data-v-0c5c6736="" class="el-col el-col-24">
            <div data-v-0c5c6736="" class="el-card is-never-shadow" style="display: none;">
                <div class="el-card__body" style="padding: 16px; text-align: left;">
                    <div data-v-0c5c6736="" class="G-title"><span data-v-0c5c6736="">注意事项</span></div>
                    <div data-v-0c5c6736="">
                        <ol data-v-0c5c6736="" style="padding-inline-start: 15px;">
                            <li data-v-0c5c6736="">本站秉持信息中立，不接受任何付费发布以及信息置顶。<strong data-v-0c5c6736=""
                                    style="color: rgb(255, 51, 153);">请不要因为发布信息去升级VIP会员</strong>，信息审核和会员等级无关，我们的信息的审核标准只是需要真实、无套路、不忽悠。
                            </li>
                            <li data-v-0c5c6736="">
                                请勿投递良家、裸聊、欺诈类的信息，此类投递将会永久封禁你的账号和访问IP。对于恶意欺诈、泄漏他人隐私，一旦收到举报，我们会把你的用户信息以及IP提供给受害者进一步处理，请好自为之。
                            </li>
                            <li data-v-0c5c6736="">近期屡有狼友上当受骗，对于黑中介、外围经纪、全国空降、纯上门服务这几类欺诈重灾区的信息一律不再通过，请勿浪费时间发布。</li>
                            <li data-v-0c5c6736=""><span data-v-0c5c6736="" style="color: rgb(255, 51, 153);"><strong
                                        data-v-0c5c6736="">我们不会以任何形式去联络信息中的联系方式，更不会索要任何照片以及钱财，任何号称“一楼一凤管理”或者“一楼一凤官方”的人，都是骗子，请勿上当受骗。</strong></span>
                            </li>
                            <li data-v-0c5c6736=""><span data-v-0c5c6736="" style="color: rgb(255, 51, 153);"><strong
                                        data-v-0c5c6736="">我们没有任何对外的微信、QQ、telegram（电报）、电报群，联系本站客服只能通过邮箱fengloukefu@gmail.com，任何通过微信、QQ、telegram（电报）、电报群跟发帖人联系的均是骗子。</strong></span>
                            </li>
                            <li data-v-0c5c6736=""><span data-v-0c5c6736="" style="color: rgb(255, 51, 153);"><strong
                                        data-v-0c5c6736="">如果碰到索要钱财和视频、自称官方、自称审核员，请保留证据发邮件举报到fengloukefu@gmail.com，我们会对你的信息进行保护并且曝光骗子。</strong></span>
                            </li>
                            <li data-v-0c5c6736=""><strong data-v-0c5c6736="">请在发布信息的时候注意以下几个原则：</strong>
                                <ul data-v-0c5c6736="">
                                    <li data-v-0c5c6736="">请负责的选择基本信息，包括年龄、价格、地区，确保信息的准确性。</li>
                                    <li data-v-0c5c6736="">上传图片的信息将会被优先通过，基于隐私你可以对面部以及带有特征部位的地方马赛克处理。</li>
                                    <li data-v-0c5c6736="">任何一个信息重复发布是次数低于3天一次，多次重复将不会被通过，当天重复发布的信息只会通过最早的1个。</li>
                                    <li data-v-0c5c6736="">对于楼凤、经纪人以及商家，我们建议直接在详细介绍里发布课表或服务价格介绍，不要去编故事。</li>
                                    <li data-v-0c5c6736="">认真填写联系方式，没有的联系方式留空，多个联系方式用空格断开，除了联系方式不要写其他任何无关内容。</li>
                                    <li data-v-0c5c6736="">价格请填写最低的单次价格，如有其他套餐和价格补充在详细介绍里。</li>
                                </ul>
                            </li>
                            <li data-v-0c5c6736=""><strong data-v-0c5c6736="">体验报告类信息的发布指导规范</strong>
                                <ul data-v-0c5c6736="">
                                    <li data-v-0c5c6736="">请认真描述体验过程，不要编故事和抄袭故事，描述不少于50个字，不要敷衍了事。</li>
                                    <li data-v-0c5c6736="">请在描述的过程之后，对服务项目和价格也做一些介绍。</li>
                                    <li data-v-0c5c6736="">上传图片附带马赛克合影照片并且带有“一楼一凤“验证”的信息会被优先通过。</li>
                                </ul>
                            </li>
                            <li data-v-0c5c6736=""><strong data-v-0c5c6736="">楼凤商家类信息的发布指导规范</strong>
                                <ul data-v-0c5c6736="">
                                    <li data-v-0c5c6736="">请直接发布详细的项目以及价格介绍，或者附加一些特色介绍，不要编故事。</li>
                                    <li data-v-0c5c6736="">本站不接受号称全能型（什么都做、那里都有）的商家和经纪人类信息，不要浪费时间发布。</li>
                                    <li data-v-0c5c6736="">上传图片附带手持“一楼一凤”验证的信息会被优先通过。</li>
                                </ul>
                            </li>
                            <li data-v-0c5c6736=""><strong data-v-0c5c6736="">一楼一凤照片验证指导</strong>
                                <ul data-v-0c5c6736="">
                                    <li data-v-0c5c6736="">手持一张写有一楼一凤以及当天时间的纸张合影（隐私区域可以马赛克）。</li>
                                    <li data-v-0c5c6736="">手持带有一楼一凤LOGO图片的手机画面或者纸张合影（隐私区域可以马赛克）。</li>
                                    <li data-v-0c5c6736="">手持手机打开一楼一凤网站并且与之一起的自拍合影（隐私区域可以马赛克）。</li>
                                </ul>
                            </li>
                            <li data-v-0c5c6736=""><strong data-v-0c5c6736="">请注意，以下类型的信息不会被审核通过(定期更新)：</strong>
                                <ul data-v-0c5c6736="">
                                    <li data-v-0c5c6736="">要支付定金或者车费，以及任何需要提前付费的信息；</li>
                                    <li data-v-0c5c6736="">号称什么都有，什么地区都可以的信息；</li>
                                    <li data-v-0c5c6736="">图片里带有联系方式截图的信息；</li>
                                    <li data-v-0c5c6736="">描述内容敷衍了事，一句“自己体验”或“很好”了事的信息；</li>
                                    <li data-v-0c5c6736="">没写、乱写或者忘记写联系方式的信息；</li>
                                    <li data-v-0c5c6736="">标题很长和过于浮夸，刻意吸引眼球以及文不对题的信息；</li>
                                    <li data-v-0c5c6736="">使用系统默认的超长微信号作为联系方式的信息；</li>
                                    <li data-v-0c5c6736="">乱写单次价格或包夜价格的信息；</li>
                                    <li data-v-0c5c6736="">盗取已审核信息图片或他人图片的信息；</li>
                                    <li data-v-0c5c6736="">详细介绍里夹杂联系方式的信息；</li>
                                </ul>
                            </li>
                        </ol> <a data-v-0c5c6736="" href="/help" class="navbar-nav"><button data-v-0c5c6736=""
                                type="button" class="el-button el-button--default el-button--small is-plain"><span><svg
                                        data-v-73b7ef61="" data-v-0c5c6736="" aria-hidden="true" class="svg-icon"
                                        style="fill: rgb(255, 51, 153);">
                                        <use data-v-73b7ef61="" xlink:href="#icon-rule"></use>
                                    </svg>
                                    信息规则
                                </span></button></a>
                        <div data-v-0c5c6736="" style="text-align: center;"><button data-v-0c5c6736="" type="button"
                                class="el-button el-button--primary"><span>我已阅读以上信息发布规范</span></button></div>
                    </div>
                </div>
            </div>
            <div data-v-0c5c6736="" class="el-card is-never-shadow" style="">
                <div class="el-card__body" style="padding: 16px; text-align: left;">
                    <div data-v-0c5c6736="" class="G-title"><span data-v-0c5c6736="">信息发布</span></div>
                    <form data-v-0c5c6736="" class="el-form" :model="forms">
                        <div data-v-0c5c6736="" class="el-form-item is-required"><label for="title"
                                class="el-form-item__label">信息标题</label>
                            <div class="el-form-item__content">
                                <div data-v-0c5c6736="" class="el-input">
                                    <input type="text" v-model="forms.title" autocomplete="off" placeholder="请填写你的信息标题" class="el-input__inner">
                                </div>
                            </div>
                        </div>
                        <div data-v-0c5c6736="" class="el-form-item is-required">
                            <label for="cid" class="el-form-item__label">所属地区</label>
                            <div class="el-form-item__content">
                                <br>
                                <el-cascader :options="shengshi" v-model="forms.city" style="width: 100%;"></el-cascader>
                            </div>
                        </div>
                        <div data-v-0c5c6736="" class="el-form-item is-required"><label for="age"
                                class="el-form-item__label">小姐年龄</label>
                            <div class="el-form-item__content">
                                <el-select v-model="forms.xiaojienianlingvalue" placeholder="请选择小姐年龄范围" style="width: 100%;">
                                    <el-option
                                    v-for="item in xiaojienianling"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div data-v-0c5c6736="" class="el-form-item is-required"><label for="face"
                                class="el-form-item__label">小姐颜值</label>
                            <div class="el-form-item__content">
                                <el-select v-model="forms.yanzhipingfenvalue" placeholder="请选择小姐颜值评分" style="width: 100%;">
                                    <el-option
                                    v-for="item in yanzhipingfen"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div data-v-0c5c6736="" class="el-form-item is-required"><label for="price"
                                class="el-form-item__label">消费水平</label>
                            <div class="el-form-item__content">
                                <div data-v-0c5c6736="" class="el-input">
                                    <input type="text" v-model="forms.price" autocomplete="off" placeholder="请填服务价格或者消费水平范围" class="el-input__inner">
                                </div>
                            </div>
                        </div>
                        <div data-v-0c5c6736="" class="el-form-item is-required"><label for="project"
                                class="el-form-item__label">服务项目</label>
                            <div class="el-form-item__content">
                                <div data-v-0c5c6736="" class="el-textarea">
                                    <textarea autocomplete="off" v-model="forms.project" rows="3" placeholder="填写服务项目，参考：鸳鸯浴、艳舞、按摩、波推、指滑、臀推、毒龙、舌吻、环游、吹箫、六九、口爆、深喉、颜射、丝袜制服"
                                        class="el-textarea__inner" style="min-height: 33px;"></textarea>
                                    </div>
                            </div>
                        </div>
                        <div data-v-0c5c6736="" class="el-form-item is-required"><label for="process"
                                class="el-form-item__label">详细介绍</label>
                            <div class="el-form-item__content">
                                <div data-v-0c5c6736="" class="el-textarea">
                                    <textarea autocomplete="off" v-model="forms.process" rows="3" placeholder="详情填写整个服务体验的详细介绍，有助于审核通过" class="el-textarea__inner" style="min-height: 33px;"></textarea>
                                </div>
                                <div data-v-0c5c6736="" class="p4">* 填写详细介绍将会有助于审核，过于简短将不会被审核通过。</div>
                            </div>
                        </div>
                        <div data-v-0c5c6736="" class="el-form-item"><label for="QQ"
                                class="el-form-item__label">QQ</label>
                            <div class="el-form-item__content">
                                <div data-v-0c5c6736="" class="el-input">
                                    <input type="text" v-model="forms.qq" autocomplete="off" placeholder="请填写QQ联系方式" class="el-input__inner">
                                </div>
                            </div>
                        </div>
                        <div data-v-0c5c6736="" class="el-form-item"><label for="wechat"
                                class="el-form-item__label">微信</label>
                            <div class="el-form-item__content">
                                <div data-v-0c5c6736="" class="el-input">
                                    <input type="text" v-model="forms.wechat" autocomplete="off" placeholder="请填写微信联系方式" class="el-input__inner">
                                </div>
                            </div>
                        </div>
                        <div data-v-0c5c6736="" class="el-form-item"><label for="phone"
                                class="el-form-item__label">电话</label>
                            <div class="el-form-item__content">
                                <div data-v-0c5c6736="" class="el-input">
                                    <input type="text" v-model="forms.phone" autocomplete="off" placeholder="请填写手机联系方式" class="el-input__inner">
                                </div>
                            </div>
                        </div>
                        <div data-v-0c5c6736="" class="el-form-item"><label for="address"
                                class="el-form-item__label">地址</label>
                            <div class="el-form-item__content">
                                <div data-v-0c5c6736="" class="el-input">
                                    <input type="text" v-model="forms.address" autocomplete="off" placeholder="填写服务场所详细地址或者大概地址" class="el-input__inner">
                                </div>
                            </div>
                        </div>
                        <div data-v-0c5c6736="" class="el-form-item"><label for="privacy"
                                class="el-form-item__label">隐私设置</label>
                            <div class="el-form-item__content"><br data-v-0c5c6736="">
                                <el-select v-model="forms.yinsivalue" placeholder="请选择" style="width: 100%;">
                                    <el-option
                                    v-for="item in yinsi"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div data-v-0c5c6736="" class="el-form-item"><label for="photo"
                                class="el-form-item__label">照片</label>
                            <div class="el-form-item__content"><br data-v-0c5c6736="">
                                <div data-v-0a456342="" data-v-0c5c6736="">
                                    <el-upload
										action="/api/publish_uploads"
										list-type="picture-card"
										:multiple="true"
										:on-remove="handleRemove"
										:on-success="uploadSuccess">
									<i class="el-icon-plus"></i>
									</el-upload>
                                </div>
                                <div data-v-0c5c6736="" class="p4">* 上传照片，将会有助于审核通过。</div>
                            </div>
                        </div>
                        <div data-v-0c5c6736="" class="el-form-item form-group">
                            <div class="el-form-item__content"><button data-v-0c5c6736 @click="form_submit" type="button" class="el-button el-button--primary"><span>确认发布</span></button></div>
                        </div>
                        <div data-v-0c5c6736 class="text-dark">请注意，以下情况不会被审核通过：</div>
                        <div data-v-0c5c6736 class="p4">* 一条信息只可提交一次，如多次提交，拒绝审核。</div>
                        <div data-v-0c5c6736 class="p4">* 要支付定金或者车费的。</div>
                        <div data-v-0c5c6736 class="p4">* 号称什么都有什么地区都可以的。</div>
                        <div data-v-0c5c6736 class="p4">* 没写联系方式的。</div>
                        <div data-v-0c5c6736 class="p4">* 描述内容敷衍了事的。</div>
                        <div data-v-0c5c6736 class="p4">* 信息审核通过后，奖励20-50积分</div>
                        <div data-v-0c5c6736 class="text-dark" style="color: rgb(249, 135, 0);">认真投递的优质内容，特别是带有图片的优质内容，一旦审核通过，除了其他用户查看会获得相应积分，还会获得一次性奖励积分。</div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'publish',
    data() {
        return {

            forms:{
                imgArr:[],
                thUmbs:'',
            },

            shengshi: [],
            xiaojienianling:[
                {
                    value:'1',
                    label:'18-20岁'
                },
                {
                    value:'2',
                    label:'20-25岁'
                },
                {
                    value:'3',
                    label:'25-30岁'
                },
                {
                    value:'4',
                    label:'30-35岁'
                },
                {
                    value:'5',
                    label:'35-40岁'
                },
                {
                    value:'6',
                    label:'40+'
                },
            ],
            xiaojienianlingvalue:'',
            yanzhipingfen:[
                {
                    value:'1',
                    label:'1'
                },
                {
                    value:'2',
                    label:'2'
                },
                {
                    value:'3',
                    label:'3'
                },
                {
                    value:'4',
                    label:'4'
                },
                {
                    value:'5',
                    label:'5'
                },
                {
                    value:'6',
                    label:'6'
                },
                {
                    value:'7',
                    label:'7'
                },
                {
                    value:'8',
                    label:'8'
                },
                {
                    value:'9',
                    label:'9'
                },
                {
                    value:'10',
                    label:'10'
                }
            ],
            yanzhipingfenvalue:'',
            yinsi:[
                {
                    value:1,
                    label:'匿名发布'
                },
                {
                    value:2,
                    label:'显示用户名',
                }
            ],
            yinsivalue:'',

        }
    },
    methods:{
        form_submit(){

            if(this.forms.title){
                if(this.forms.city){
                    if(this.forms.xiaojienianlingvalue){
                        if(this.forms.yanzhipingfenvalue){
                            if(this.forms.price){
                                if(this.forms.project){
                                    if(this.forms.process){
                                        if(this.forms.qq){
                                            if(this.forms.wechat){
                                                if(this.forms.phone){
                                                    if(this.forms.address){
                                                        if(this.forms.yinsivalue){

                                                            this.$http.post('/api/publish',{form:this.forms}).then(res=>{

                                                                if(res.data.code==1){
                                                                    this.$message({
                                                                        message: res.data.msg,
                                                                        type: 'success',
                                                                        onClose:()=>{
                                                                            window.location.href = 'show?id='+res.data.id;
                                                                        }
                                                                    });
                                                                }
                                                            })
                                                            
                                                        }else{
                                                            this.$message({
                                                                message: '请选择隐私设置',
                                                                type: 'error'
                                                            });
                                                        }
                                                    }else{
                                                        this.$message({
                                                            message: '请输入地址',
                                                            type: 'error'
                                                        });
                                                    }
                                                }else{
                                                    this.$message({
                                                        message: '请输入电话',
                                                        type: 'error'
                                                    });
                                                }
                                            }else{
                                                this.$message({
                                                    message: '请输入微信',
                                                    type: 'error'
                                                });
                                            }
                                        }else{
                                            this.$message({
                                                message: '请输入QQ',
                                                type: 'error'
                                            });
                                        }
                                    }else{
                                        this.$message({
                                            message: '请输入详细介绍',
                                            type: 'error'
                                        });
                                    }
                                }else{
                                    this.$message({
                                        message: '请输入服务项目',
                                        type: 'error'
                                    });
                                }
                            }else{
                                this.$message({
                                    message: '请输入消费水平',
                                    type: 'error'
                                });
                            }
                        }else{
                            this.$message({
                                message: '请选择小姐颜值',
                                type: 'error'
                            });
                        }
                    }else{
                        this.$message({
                            message: '请选择小姐年龄',
                            type: 'error'
                        });
                    }
                }else{
                    this.$message({
                        message: '请选择地区',
                        type: 'error'
                    });
                }
            }else{
                this.$message({
                    message: '请输入信息标题',
                    type: 'error'
                });
            }

        },
        handleRemove(file, fileList){

            let fileedit = this.forms.imgArr;
        
            for (let i = 0; i < fileedit.length; i++) {
                
                let imgArrs = this.forms.imgArr[i];
                
                if (file.response == imgArrs) {
                    
                    this.forms.imgArr.splice(i,1)
                    
                }
            }

        },
        uploadSuccess(response, file, fileList){

            this.forms.imgArr.push(response)

            this.$http.post('/api/thumbuploads',{file:this.forms.imgArr[0]}).then(res=>{

                this.forms.thUmbs = res.data

            })

        }
    },
    mounted() {

        this.$http.get('/api/publish_city').then(res=>{

            this.shengshi = res.data
            
        })
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>


// WEBPACK FOOTER //
// src/components/publish.vue